<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>参赛作品管理</el-breadcrumb-item>
      <el-breadcrumb-item>参赛作品分组</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width: 360px !important; margin-right: 20px">
          <el-select
            v-model="queryInfo.MatchID"
            placeholder="请选择赛项名称"
            clearable
            @change="selectGettrack(queryInfo.MatchID, 0)"
            style="width: 360px !important"
          >
            <el-option
              v-for="item in matchNameoptions"
              :key="item.MatchID"
              :label="item.MatchName"
              :value="item.MatchID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" style="margin-right:20px;">
          <el-select
            v-model="queryInfo.TrackID"
            placeholder="请选择赛道"
            clearable
            style="width:360px !important;"
          >
            <el-option
              v-for="item in trackNameoptions"
              :key="item.TrackID"
              :label="item.TrackName"
              :value="item.TrackID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getGroupingList(1)"
            >搜索</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-s-platform"
            type="success"
            @click="systemDialog('sys')"
            >系统分配</el-button
          >
        </el-col>
        <el-col :span="2" class="btnend">
          <el-button
            icon="el-icon-s-tools"
            type="warning"
            @click="systemDialog('ch')"
            >重新分配</el-button
          >
        </el-col>
        <el-col :span="1" style="margin-left:20px;">
          <el-button icon="el-icon-download" type="success" @click="doDown"
            >导出</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称"></el-table-column>
        <el-table-column prop="TrackName" label="赛道"></el-table-column>
        <el-table-column prop="JudgesGroupName" label="小组名称">
        </el-table-column>
        <el-table-column prop="ProfessionalFields" label="专业领域">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              v-for="item in scope.row.ProfessionalFields"
              :key="item.ProfessionalFieldID"
              class="proftag"
              >{{ item.ProfessionalFieldName }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="JudgesList" label="评委">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              v-for="item in scope.row.JudgesList"
              :key="item.JudgesID"
              class="proftag"
              type="warning"
              >{{ item.JudgesName }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-badge :value="scope.row.NumberOfItemsAllocated">
              <el-button
                type="primary"
                icon="el-icon-view"
                size="mini"
                plain
                @click="showView(scope.row)"
                >查看已分配作品</el-button
              >
            </el-badge>
            <el-badge :value="scope.row.UnassignedItemQuantity" type="primary">
              <el-button
                type="warning"
                icon="el-icon-setting"
                size="mini"
                plain
                @click="showAssign(scope.row)"
                >手动分配作品</el-button
              >
            </el-badge>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>

      <!-- 查看已分配作品 -->
      <el-dialog
        title="查看已分配作品"
        :visible.sync="viewDialogVisible"
        width="50%"
      >
        <el-table
          :data="onPagedata"
          border
          style="width: 100%"
          ref="allonRef"
          size="mini"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="#" width="50"> </el-table-column>
          <el-table-column prop="EntriesName" label="作品名称"></el-table-column>
          <el-table-column prop="School" label="所属学校" width="150">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="viewDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="assignItems()">移除分配</el-button>
        </span>
      </el-dialog>
      <!-- 手动分配作品 -->
      <el-dialog
        title="手动分配作品"
        :visible.sync="assignDialogVisible"
        width="40%"
      >
        <el-table
          :data="allPagedata"
          border
          style="width: 100%"
          ref="allRef"
          size="mini"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="#" width="50"> </el-table-column>
          <el-table-column prop="EntriesName" label="作品名称"></el-table-column>
          <el-table-column prop="School" label="所属学校" width="150"></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="assignDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="allocation()">确定分配</el-button>
        </span>
      </el-dialog>

      <!-- 选择系统分配赛事 -->
      <el-dialog
        :title="distributionType === 'sys' ? '系统分配' : '重新分配'"
        :visible.sync="selectDialogVisible"
        width="30%"
      >
        <el-select
          v-model="MatchID"
          placeholder="请选择赛项名称"
          style="width: 360px !important; margin-right: 20px"
          clearable
        >
          <el-option
            v-for="item in matchNameoptions"
            :key="item.MatchID"
            :label="item.MatchName"
            :value="item.MatchID"
          >
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="selectDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="
              distributionType === 'sys'
                ? systemAllocation(MatchID)
                : reassign(MatchID)
            "
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项id
        MatchID: '',
        // 赛道id
        TrackID: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 添加弹框显示状态
      viewDialogVisible: false,
      // 修改弹框显示状态
      assignDialogVisible: false,
      // 系统分配选择赛事状态
      selectDialogVisible: false,
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 赛道下拉选项
      trackNameoptions: [
        {
          value: '1',
          label: '赛道1'
        },
        {
          value: '2',
          label: '赛道2'
        }
      ],
      // 已分配作品
      onPagedata: [],
      // 手动分配作品
      allPagedata: [],
      // 当前分配数据
      thisProjectRow: [],
      proobj: {
        // 当前分配小组id
        judgesGroupId: 0,
        entriesIds: []
      },
      // 系统分配、重新分配类型
      distributionType: '',
      // 系统分配赛事id
      MatchID: ''
    }
  },
  created() {
    //   默认获取列表
    this.getGroupingList(1)
    // 默认获取赛事
    this.getAllMatch()
  },
  methods: {
    //   获取分组列表
    async getGroupingList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/JudgesGroup/GetJudgesGroups',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.judgesGroups
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
    },
    // 下拉赛项获取对应赛道
    async selectGettrack(id) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.$set(this.queryInfo, 'TrackID', null)
      this.trackNameoptions = res.Data.tracks
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getGroupingList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getGroupingList(newPage)
    },
    // 显示查看已分配作品弹窗
    async showView(row) {
      // 发起添加请求
      const { data: res } = await this.$http.get(
        '/api/EntriesJudgesGroup/GetDistributionEntries',
        {
          params: {
            MatchID: row.MatchID,
            TrackID: row.TrackID,
            JudgesGroupID: row.JudgesGroupID
          }
        }
      )
      // 判断状态码
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.onPagedata = res.Data.entries
      // 打开弹窗
      this.viewDialogVisible = true
    },
    // 移除分配
    async assignItems() {
      // 已选中的作品
      var currentSelect = this.$refs.allonRef.selection
      // 取出选中移除作品id放入数组
      this.thisProjectRow = currentSelect.map((item) => item.EntriesID)
      const { data: res } = await this.$http.post(
        '/api/EntriesJudgesGroup/DeleteDistributionEntries',
        this.thisProjectRow
      )
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.$message.success(res.Msg)
      this.viewDialogVisible = false
      this.getGroupingList(this.queryInfo.pagenum)
    },
    // 显示手动分配作品弹窗
    async showAssign(row) {
      this.proobj.judgesGroupId = row.JudgesGroupID
      // 发起添加请求
      const { data: res } = await this.$http.get(
        '/api/EntriesJudgesGroup/GetUnDistributionEntries',
        {
          params: {
            MatchID: row.MatchID,
            TrackID: row.TrackID,
            JudgesGroupID: row.JudgesGroupID
          }
        }
      )
      // 判断状态码
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.allPagedata = res.Data.entries
      // 打开弹窗
      this.assignDialogVisible = true
    },
    // 确定分配
    async allocation() {
      // 已选中的作品
      var currentSelect = this.$refs.allRef.selection
      // 取出选中移除作品id放入数组
      this.proobj.entriesIds = currentSelect.map((item) => item.EntriesID)
      const { data: res } = await this.$http.post(
        '/api/EntriesJudgesGroup/ManualEntriesDistribution',
        {
          judgesGroupId: this.proobj.judgesGroupId,
          entriesIds: this.proobj.entriesIds
        }
      )
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.$message.success(res.Msg)
      this.assignDialogVisible = false
      this.getGroupingList(this.queryInfo.pagenum)
    },
    systemDialog(str) {
      this.distributionType = str
      this.selectDialogVisible = true
    },
    // 系统分配
    async systemAllocation(id) {
      if (this.MatchID) {
        // 提示是否确认系统分配
        const res = await this.$confirm(
          '确认系统分配吗? 系统分配将按照每个赛道中提交的作品数量，平均分配给对应赛道中的小组',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch((err) => {
          return err
        })
        if (res !== 'confirm') return this.$message.info('已取消系统分配')
        const loading = this.$loading({
          lock: true,
          text: '正在分配中,请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: resdel } = await this.$http.post(
          '/api/EntriesJudgesGroup/EntriesDistribution?matchId=' + id
        )
        loading.close()
        if (resdel.StatusCode !== 1) return this.$message.error(resdel.Msg)
        this.selectDialogVisible = false
        this.$message.success(resdel.Msg)
        // 刷新列表
        this.getGroupingList(1)
      } else {
        this.$message.error('请先选择赛事名称')
      }
    },
    // 重新分配
    async reassign(id) {
      if (this.MatchID) {
        // 提示是否确认重新分配
        const res = await this.$confirm(
          '确认重新分配吗? 重新分配将会清空小组中已分配的作品',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).catch((err) => {
          return err
        })
        if (res !== 'confirm') return this.$message.info('已取消重新分配')
        // 输入管理员系统密码验证通过后,再分配
        this.PasswordVerification(id)
        // const { data: resdel } = await this.$http.post(
        //   '/api/EntriesJudgesGroup/ResetDistribution?matchId=' + id
        // )
        // if (resdel.StatusCode !== 1) return this.$message.error(resdel.Msg)
        // this.selectDialogVisible = false
        // this.$message.success(resdel.Msg)
        // // 刷新列表
        // this.getGroupingList(1)
      } else {
        this.$message.error('请先选择赛事名称')
      }
    },
    // 密码验证后分配
    PasswordVerification(id) {
      this.$prompt('请输入管理员密码验证', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'promptcss',
        inputPattern: /^.+$/,
        inputErrorMessage: '不能为空'
      }).then(({ value }) => {
        if (value) {
          this.$http
            .get('api/Judges/VerificationAdminPwd', {
              params: {
                pwd: value
              }
            })
            .then(async (res) => {
              if (res.data.StatusCode !== 1) return this.$message.error(res.data.Msg)
              const { data: resdel } = await this.$http.post(
                '/api/EntriesJudgesGroup/ResetDistribution?matchId=' + id
              )
              if (resdel.StatusCode !== 1) return this.$message.error(resdel.Msg)
              this.selectDialogVisible = false
              this.$message.success(resdel.Msg)
              // 刷新列表
              this.getGroupingList(1)
            })
        } else {
          this.$message.error('请先输入密码!')
        }
      })
    },
    // 导出
    doDown() {
      this.$http
        .get('api/EntriesJudgesGroup/ExportEntriesAss', { params: this.queryInfo })
        .then((res) => {
          const a = document.createElement('a')
          const href = res.data.Data
          a.href = href
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
    }
  }
}
</script>
<style lang="less">
.btnend {
  margin-left: 30px;
}
.el-badge {
  margin: 9px;
}
.promptcss {
  .el-message-box__message {
    p {
      color: red;
    }
  }
}
</style>
